import React from 'react';
import './css/index.css';
import './css/set1.css';
import {Link} from "react-router-dom";

// export function onSetLanguage () {
//     strings.setLanguage('du');
// }
function cfDecodeEmail() {
    let encodedString = "0777756e7166647e4777686b6e736e7629696273"
    var email = "", r = parseInt(encodedString.substr(0, 2), 16), n, i;
    for (n = 2; encodedString.length - n; n += 2){
        i = parseInt(encodedString.substr(n, 2), 16) ^ r;
        email += String.fromCharCode(i);
    }
    window.location.href = `mailto:${email}`;
}

const language = localStorage.getItem('language') || 'EN';

const data = {
    EN: {
        0: "For the political animal",
        1: "Email",
        2: "Password*",
        3: "Remember Me",
        4: "Log in",
        5: "Not a member? Click here",
        6: "Forgot Password?",
        7: "Username (No spaces, please.)",
        8: "First Name (Yes, your real first name)",
        9: "Last Name (Same as above)",
        10: "Display Name (What the world will see)",
        11: "Sign up",
        12: "Politics",
        13: "You're about to go to the forums where you can discuss the site itself. The forums use Disqus which requires an external login, so if you'd like to participate you'll need to sign in there. ",
        14: "Continue",
        15: "About us",
        16: "Contact",
        17: "Privacy Policy",
        18: <h2>This all depends on
          <span className="title-accent">your </span>
            <span className="title-accent-more">participation!</span>
            <span className="itallic text-right">Barack Obama</span></h2>,
        19: <div className="contenttext">
            <h2 className="red">We're the new kid in town</h2>
            <p>A new social platform dedicated to politics. We're taking the good ingredients from the current set of social networks and adding a few new ones to make a unique experience. We're just getting started and welcome your feedback for improvements and what you want more of.</p>
        </div>,
        20: "It’s all about",
        21: "Vacation pics are indeed nice, but not here. You're here to change the world. And you'll do so by talking politics and voting and interacting with politicians. Don't worry, we'll keep your real identity hidden so you can feel free to speak up.",
        22: "No Ads",
        23: "We're a part of the natural shift away from ad-based business models. No ads, no data-mining, no marketing what-so-ever. You are the consumer, not the product. We'll eventually ask a minimal fee to participate on the site, pricing on the basis of the GDP per capita of your country. You may think it sucks paying for stuff, but getting screwed sucks worse. Exercise your power and pay for the service. When you pay for it, you control it.",
        24: "Twitter too harsh? Facebook fake?",
        25: "We're creating a friendlier, more constructive forum here. Anonymity without repercussion is a recipe for disaster. Let's add reputation to the mix. And it's time for intimacy in our discussion, because talking to everyone in the world at the same time will either create a plastic discussion or a hostile one. Neither will help. Let's see if we can tweak the knobs for better sound.",
        26: "Goals",
        27: "Talk is cheap, progress takes action. Create goals and let the community take action around those goals.",
        28: "Anonymous but Real",
        29: "You don't have to reveal your name or location on the site. But you do need to be a real person. The system knows who you really are, but you're free to wear a mask online.",
        30: "Global but Intimate",
        31: "Talking politics with strangers may not be for you. The site lets you talk more intimately to friends and followers.",
        32: "Integrated political data",
        33: "Your politicians, government officials, elections and their candidates will all be natively integrated into the site. They're automatically a part of the experience.",
        34: <span><h2>You can vote at any time!</h2><p>Why wait every couple of years to vote? Let's start a new system of accountability here. We need more frequent and innovative ways to show our leaders how we feel. Gamified voting is just the start.</p></span>,
        35: <span><h2 className="text-white">The Opposite</h2><p className="text-white">Let's try the opposite: use a different set of incentives to create a quality conversation and a different set of tools to take action. And let's change the money trail to put the users in the driver's seat. How's that for different!?</p></span>,
        36: "2019 Politiq All rights reserved",
        37: "Blog",
        38: "Community",
        39: "Pollies",
        40: "New",
        41: "Members",
        42: "Home",
        43: "My Stuff",
        44: "Settings",
        45: "Audiences",
        46: "logout",
        47: "Welcome",
        48: "What is your political mood for today",
        49: "You can add a title, if you want",
        50: "Go ahead, spill your guts! Don't forget to tag the politicians, organizations, countries, and topics involved in your post. ",
        51: "Privacy Settings",
        52: "Full Post",
        53: "Publish",
        54: "add tags",
        55: "My Pollies",
        56: "Upcoming elections",
        57: "See all",
        58: <div>We've got 3 buttons to choose from! You can reply in Private so that only the author can see your comment, you can reply to your Friends so that only your friends can see your comment, or the Whole World, so that everyone can see it.<br />Reply in Private is obviously the coolest one, so have a look at the video to see more on what that's about.</div>,
        59: "Write a comment...",
        60: "Private",
        61: "Group",
        62: "Public",
        63: "Replying",
        64: <div>Post whatever articles or thoughts you have related to politics. A lot like other social networks, but still a bit unique. Here are some of the features: <ul><li>- paste a URL to show a preview of the link</li><li>- add a title, if you like</li><li>- click on Privacy Settings to select not only who can see a post, but also who can reply to it</li><li>- click on Full Post to get an additional Description field which will help summarize the post for certain overviews</li><li>- in Full Post mode you can also Save as Draft</li><li>- add Tags and/or images to a post (if you tag a polly, your post will also display on their page for those who are able to view it</li></ul></div>,
        65: "Posting on Politiq",
        66: "Loading...",
        67: "Remove this draft",
        68: "New Post",
        69: "What's this post about? Sum it up here.",
        70: "My Posts and comments: Who can see them",
        71: "Selected audience",
        72: "Just friends",
        73: "Friends and followers (and everyone else who's listening)",
        74: <legend className="cdw">My Posts and comments: Who can comment on them <span className="explain cdw">(obviously they'll have to be able to read them)</span></legend>,
        75: "Publish Post",
        76: "Save as Draft",
        77: "Name",
        78: "Just the politician in question",
        79: "You don't have any audiences defined to use this option. If you wish to create them for this post, save this as a draft (in Full Post mode) and then go to the Audiences page to create audiences.",
        80: "Close",
        81: "Choose Files",
        82: "file was chosen",
        83: "Choose files to upload",
        84: "add images",
        85: "help",
        86: "male",
        87: "female",
        88: "Unwatch",
        89: "Watching",
        90: "Watch",
        91: "Unwatch closely",
        92: "Watching closely",
        93: "Watch closely",
        94: "Search",
        95: "Politicians you vote for",
        96: "Click to see them in the news",
        97: "Let them know how you feel about them",
        98: "Share on Facebook",
        99: "Share on Twitter",
        100: " you voted",
        101: "How do you feel about them today?",
        102: "No thanks",
        103: "Cancel",
        104: "can see this",
        105: "Who can see this?",
        106: "Submit",
        107: "I just voted ONLINE for",
        108: "It doesn't count but count on me to do it next election.",
        109: "Care to explain?",
        110: "Ability",
        111: "Vision",
        112: "On Politiq, you can watch politicians and government officials (or, pollies, as we call them). There are two flavors: standard Watching and Watching Closely. Watching them closely just means that you will get an email notification if they post on Politiq. You might want to know right away if certain pollies post, and watching closely keeps you up to date quickly. Normal watching just means that their posts will show up in your feed. You won't get a separate email about their posts. \n And here is where you can vote every day on the pollies you love (and those you wish were doing better). Just move the two sliders to the desired level and click Submit. Your good deed is done for today, but you can vote again tomorrow.",
        113: "It may not be election season but you can vote here every day!",
        114: "Yesterday's Score: Vision:",
        115: "on ",
        116: "Thanks for voting today, you can vote again tomorrow",
        117: "to vote",
        118: "People's Voice",
        119: "be the first to comment on this election",
        120: "to comment",
        121: "In the News",
        122: "3 minutes ago.",
        123: "There are no news to show",
        124: "Related Pollies",
        125: "Add New Audience",
        126: "Set this audience as my default one.",
        127: "Audience Name",
        128: "Add",
        129: "Audiences are a way to limit who sees your posts. Create an audience here, add friends to it, and then select one or more audiences in the Privacy Settings of a post. Only the members of the audience will see the post. Want all this in a video? Check it out: ",
        130: "Edit",
        131: "Delete",
        132: "My Friends",
        133: "Candidates",
        134: "Comments",
        135: "Related Elections",
        136: "Elections near you",
        137: "Get Reset Link",
        138: "Confirm Password",
        139: "Posts",
        140: "Friends",
        141: "Following",
        142: "Followers",
        143: "Un-watch",
        144: "Un-watch closely",
        145: "Watching closely",
        146: "Watch closely",
        147: "Unfollow",
        148: "Following",
        149: "Follow",
        150: "Unfollow closely",
        151: "Following closely",
        152: "Follow closely",
        153: "female",
        154: "male",
        155: "Quote",
        156: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.",
        157: "See more",
        158: "Claim this page",
        159: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris pellentesque volutpat mauris et sodales. Cras et enim dapibus, sodales lacus et, sodales elit.",
        160: "It may not be election season, but you can vote here every day",
        161: "Allow this person to send me emails/direct messages",
        162: "News",
        163: "commented",
        164: "Private message",
        165: "replied",
        166: "Sorry, you don’t have access to this page.",
        167: "Edit Post",
        168: "Delete Post",
        169: "No posts are here... yet.",
        170: "by",
        171: "Open",
        172: "Continue composing",
        173: "On Politiq, you can follow other people, or... follow them closely. Following them closely just means that you will get an email notification if they post on Politiq. The idea is that you want to hear immediately from some people. Following closely is the way to do that. Normal following just means that their posts will show up in your feed. You won't get a separate email about their posts.",
        174: "Edit Profile Settings",
        175: "My Posts",
        176: "Favorited Posts",
        177: "It's really you! Great! Your account has been activated. Please click login to do just that. Then fill in your profile to start off your life here with a Reputation Level of 2!",
        178: "Username",
        179: " Thank you, check your email for an activation mail. (It may be in your junk mail...)",
        180: "First Name",
        181: "Last Name",
        182: "New Password",
        183: "Delete My Account",
        184: "Update Settings",
        185: "Preview:",
        186: "OMG, I look amazing!",
        187: "My Profile - who can see it / find it",
        188: "The whole world",
        189: "Who can send me a direct message",
        190: "My Posts and comments: Who can comment on them (obviously they'll have to be able to read them)",
        191: "My votes: who can see them",
        192: "Your name as people will see it",
        193: "Tell us where you are (or where you want to be)",
        194: "I'd rather not say",
        195: "Your profile",
        196: "Your Settings",
        197: <span><p>We need to match you to your Congressional District, as well as with local policies and elections you can weigh in on.</p>
        <p>Don't feel comfortable sharing your location? No problem, simply use a nearby address in your general area. (Note: some candidates, elected officials, and issues may be inaccurate.)</p>
        <p>We will not contact you or share your private information with anyone.</p></span>,
        198: "Politi who?",
        199: <div><p>If the global conversation is so great, why do we all hate being in it? Facebook and Twitter have become focal points of dissatisfaction. We complain about the fake news, the toxic conversations, the threats of violence, and lastly how crappy we feel when we spend time on these platforms. </p><p>If we hate being on it, why are we still there? Everyone is wondering why we're all so divided, and I'm here to tell you what's really going on.
      The social web claims to give us the wisdom of crowds, but it's not delivering. No one on social media is trying to raise the global consciousness or save the world. They are only trying to be right and to be seen. In their lives, they may be trying to do good, but put them on the social web and their actions will be motivated by being right…. and being seen…. Not to be unexpected - that is what humans do if you put them in such an environment. </p><p>That environment has become a dopamine-driven ecosystem. It is a bad neighborhood taken over by drug use, and we inhabitants want to leave but can't leave, so we stay but simply treat it poorly. Bad neighborhoods themselves create downward spirals of bad behavior. When average people are put in graffiti-walled neighborhoods with trash on the streets and weeds growing on the sidewalk grooves, they are more prone themselves to disregard the law and act malevolently. This is what the social web has become. </p> <p>At the heart is the ad-based business model which profits from our drug use. Like a drug dealer, he pretends to be our friend, he even says as much, but then he takes our drug money and hands it to his bosses.</p> <p>The ad-based business model must end. Like the political revolutions of the Enlightenment, he is the Sun King that must be dragged out to the square and decapitated. The majority of our online problems are his fault. </p><p>People will always want to be right and be seen. But they also want progress. Twitter is not progress. Arguably it is practically useless. If good things have come from Twitter, it is overshadowed by lies, vanity, arrogance, and aggression. The only reason we are there is because everyone else is there. I want new places to be with better behaving people. So, I built Politiq. We value things like nice neighborhoods, healthy food, safe schools, clean houses, and good company. So, why not demand it online, especially when it comes to something as important as coordinating our lives together. The first order of business is to clean the graffiti, pick up the trash, and pull the weeds. </p>
            <p>We're not part of a technological revolution, but a cultural one. Remember that bar you and your friends used to go to? You went there because all your friends were there. Then one day somehow a bunch of you tried something new and you liked it, and that became the new place to go. Everyone was now there and it was better than the old place. </p><p>Aggression and tribalism will always be a part of humanity, but it is possible to set up an environment which turns down these dials. It will be the difference between meeting strangers in the ghetto and meeting strangers at a friend's wedding. </p><p>No technological break-though here, just cultural tweaking, but it can still lead to a revolution. Throwing out the ad-based business model and the websites that only gratify our vanity is our next Digital Age revolution.</p> <p>Fortunes will be lost, bad habits will be broken. But it will be progress. And it will feel good…eventually. What do you think? Want to try something new? It'll be buggy and raw, but it will be in the right direction. Hope you'll give it a try and we can work together to make it better. </p></div>,
        200: "Account Deleted",
        201: "Contact us",
        202: "For now, best to reach us by email: writeme [monkeytail] politiq.net",
        203: "Privacy policy (hint, it's not that bad)",
        204: <div><p>Last updated: December 02, 2021</p><p>This Privacy Policy describes Our policies and procedures on
            the collection, use and disclosure of Your information when You use the Service and tells You about Your
            privacy rights and how the law protects You.</p><p>We use the voter location data you provide to show you
            relevant political and governmental data. By using the Service, You agree to us storing that information in
            our system in accordance with this Privacy Policy. This voter location data is not shared with other users
            of the service, nor is any other actual personal information you enter on the site.</p><h1>Interpretation
            and Definitions</h1><h2>Interpretation</h2><p>The words of which the initial letter is capitalized have
            meanings defined under the following conditions. The following definitions shall have the same meaning
            regardless of whether they appear in singular or in plural.</p><h2>Definitions</h2><p>For the purposes of
            this Privacy Policy:</p>
            <ul>
                <li><p><strong>Account</strong> means a unique account created for You to access our Service or parts of
                    our Service.</p></li>
                <li><p><strong>Company</strong> (referred to as either &quot;the
                    Company&quot;, &quot;We&quot;, &quot;Us&quot; or &quot;Our&quot; in this Agreement) refers to
                    Politiq, Hoekveen 3, Hooglanderveen, The Netherlands.</p></li>
                <li><p><strong>Cookies</strong> are small files that are placed on Your computer, mobile device or any
                    other device by a website, containing local bit of personal data used to facilitate a improved
                    working of the website.</p></li>
                <li><p><strong>Country</strong> refers to: Netherlands</p></li>
                <li><p><strong>Device</strong> means any device that can access the Service such as a computer, a
                    cellphone or a digital tablet.</p></li>
                <li><p><strong>Personal Data</strong> is any information that relates to an identified or identifiable
                    individual.</p></li>
                <li><p><strong>Service</strong> refers to the Website.</p></li>
                <li><p><strong>Service Provider</strong> means any natural or legal person who processes the data on
                    behalf of the Company. It refers to third-party companies or individuals employed by the Company to
                    facilitate the Service, to provide the Service on behalf of the Company, to perform services related
                    to the Service or to assist the Company in analyzing how the Service is used.</p></li>
                <li><p><strong>Third-party Social Media Service</strong> refers to any website or any social network
                    website through which a User can log in or create an account to use the Service.</p></li>
                <li><p><strong>Usage Data</strong> refers to data collected automatically, either generated by the use
                    of the Service or from the Service infrastructure itself (for example, the duration of a page
                    visit).</p></li>
                <li><p><strong>Website</strong> refers to Politiq, accessible from <a href="https://www.politiq.net/"
                                                                                      target="_blank">https://www.politiq.net/</a>
                </p></li>
                <li><p><strong>You</strong> means the individual accessing or using the Service, or the company, or
                    other legal entity on behalf of which such individual is accessing or using the Service, as
                    applicable.</p></li>
            </ul>
            <h1>Collecting and Using Your Personal Data</h1><h2>Types of Data Collected</h2><h3>Personal Data</h3>
            <p>While using Our Service, We may ask You to provide Us with certain personally identifiable information
                that can be used to contact or identify You. Personally identifiable information may include, but is not
                limited to:</p>
            <ul>
                <li><p>Email address</p></li>
                <li><p>First name and last name</p></li>
                <li><p>Address, State, Province, ZIP/Postal code, City</p></li>
                <li><p>Usage Data</p></li>
            </ul>
            <h3>Usage Data</h3><p>Usage Data is collected automatically when using the Service.</p><p>Usage Data may
                include information such as Your Device's Internet Protocol address (e.g. IP address), browser type,
                browser version, the pages of our Service that You visit, the time and date of Your visit, the time
                spent on those pages, unique device identifiers and other diagnostic data.</p><p>When You access the
                Service by or through a mobile device, We may collect certain information automatically, including, but
                not limited to, the type of mobile device You use, Your mobile device unique ID, the IP address of Your
                mobile device, Your mobile operating system, the type of mobile Internet browser You use, unique device
                identifiers and other diagnostic data.</p><p>We may also collect information that Your browser sends
                whenever You visit our Service or when You access the Service by or through a mobile device.</p>
            <h3>Information from Third-Party Social Media Services</h3><p>The Company allows You to create an account
                and log in to use the Service through the following Third-party Social Media Services:</p>
            <ul>
                <li>Facebook</li>
                <li>Twitter</li>
            </ul>
            <p>If You decide to register through or otherwise grant us access to a Third-Party Social Media Service, We
                may collect Personal data that is already associated with Your Third-Party Social Media Service's
                account, such as Your name, and Your email address associated with that account.</p><p>You may also have
                the option of sharing additional information with the Company through Your Third-Party Social Media
                Service's account. If You choose to provide such information and Personal Data, during registration or
                otherwise, You are giving the Company permission to use, share, and store it in a manner consistent with
                this Privacy Policy.</p><h3>Tracking Technologies and Cookies</h3><p>We use Cookies and similar tracking
                technologies to track the activity on Our Service and store certain information. Tracking technologies
                used are beacons, tags, and scripts to collect and track information and to improve and analyze Our
                Service. The technologies We use may include:</p>
            <ul>
                <li><strong>Cookies or Browser Cookies.</strong> A cookie is a small file placed on Your Device. The
                    only information stored in cookies to allow for automatic signin from your device. To that effect,
                    when you click "Remember me" at login, you are effectively accepting the use of cookies for this
                    purpose.
                </li>
            </ul>
            <ul>
                <li><p><strong>Functionality Cookies</strong></p><p>Type: Persistent Cookies</p><p>Administered by:
                    Us</p><p>Purpose: These Cookies allow us to remember choices You make when You use the Website, such
                    as remembering your login details or language preference. The purpose of these Cookies is to provide
                    You with a more personal experience and to avoid You having to re-enter your preferences every time
                    You use the Website.</p></li>
            </ul>
            <h2>Use of Your Personal Data</h2><p>The Company may use Personal Data for the following purposes:</p>
            <ul>
                <li><p><strong>To provide and maintain our Service</strong>, including to monitor the usage of our
                    Service.</p></li>
                <li><p><strong>To manage Your Account:</strong> to manage Your registration as a user of the Service.
                    The Personal Data You provide can give You access to different functionalities of the Service that
                    are available to You as a registered user.</p></li>
                <li><p><strong>To contact You:</strong> To contact You by email, SMS, or other equivalent forms of
                    electronic communication, such as a mobile application's push notifications regarding updates or
                    informative communications related to the functionalities, products or services, including the
                    security updates, when necessary or reasonable for their implementation.</p></li>
                <li><p><strong>To provide You</strong> with news, special offers and general information about other
                    goods, services and events which we offer that are similar to those that you have already purchased
                    or enquired about unless You have opted not to receive such information.</p></li>
                <li><p><strong>For other purposes</strong>: We may use Your information for other purposes, such as data
                    analysis, identifying usage trends, determining the effectiveness of our promotional campaigns and
                    to evaluate and improve our Service, products, services, marketing and your experience.</p></li>
            </ul>
            <h2>Retention of Your Personal Data</h2><p>The Company will retain Your Personal Data only for as long as is
                necessary for the purposes set out in this Privacy Policy. We will retain and use Your Personal Data to
                the extent necessary to comply with our legal obligations (for example, if we are required to retain
                your data to comply with applicable laws), resolve disputes, and enforce our legal agreements and
                policies.</p><p>The Company will also retain Usage Data for internal analysis purposes. Usage Data is
                generally retained for a shorter period of time, except when this data is used to strengthen the
                security or to improve the functionality of Our Service, or We are legally obligated to retain this data
                for longer time periods.</p><h2>Transfer of Your Personal Data</h2><p>Your information, including
                Personal Data, is processed at the Company's operating offices and in any other places where the parties
                involved in the processing are located. It means that this information may be transferred to — and
                maintained on — computers located outside of Your state, province, country or other governmental
                jurisdiction where the data protection laws may differ than those from Your jurisdiction.</p><p>Your
                consent to this Privacy Policy followed by Your submission of such information represents Your agreement
                to that transfer.</p><p>The Company will take all steps reasonably necessary to ensure that Your data is
                treated securely and in accordance with this Privacy Policy and no transfer of Your Personal Data will
                take place to an organization or a country unless there are adequate controls in place including the
                security of Your data and other personal information.</p><h2>Disclosure of Your Personal Data</h2>
            <h3>Law enforcement</h3><p>Under certain circumstances, the Company may be required to disclose Your
                Personal Data if required to do so by law or in response to valid requests by public authorities (e.g. a
                court or a government agency).</p><h3>Other legal requirements</h3><p>The Company may disclose Your
                Personal Data in the good faith belief that such action is necessary to:</p>
            <ul>
                <li>Comply with a legal obligation</li>
                <li>Protect and defend the rights or property of the Company</li>
                <li>Prevent or investigate possible wrongdoing in connection with the Service</li>
                <li>Protect the personal safety of Users of the Service or the public</li>
                <li>Protect against legal liability</li>
            </ul>
            <h2>Security of Your Personal Data</h2><p>The security of Your Personal Data is important to Us, but
                remember that no method of transmission over the Internet, or method of electronic storage is 100%
                secure. While We strive to use commercially acceptable means to protect Your Personal Data, We cannot
                guarantee its absolute security.</p><h1>Children's Privacy</h1><p>Our Service does not address anyone
                under the age of 13. We do not knowingly collect personally identifiable information from anyone under
                the age of 13. If You are a parent or guardian and You are aware that Your child has provided Us with
                Personal Data, please contact Us. If We become aware that We have collected Personal Data from anyone
                under the age of 13 without verification of parental consent, We take steps to remove that information
                from Our servers.</p><p>If We need to rely on consent as a legal basis for processing Your information
                and Your country requires consent from a parent, We may require Your parent's consent before We collect
                and use that information.</p><h1>Links to Other Websites</h1><p>Our Service may contain links to other
                websites that are not operated by Us. If You click on a third party link, You will be directed to that
                third party's site. We strongly advise You to review the Privacy Policy of every site You visit.</p>
            <p>We have no control over and assume no responsibility for the content, privacy policies or practices of
                any third party sites or services.</p><h1>Changes to this Privacy Policy</h1><p>We may update Our
                Privacy Policy from time to time. We will notify You of any changes by posting the new Privacy Policy on
                this page.</p><p>We will let You know via email and/or a prominent notice on Our Service, prior to the
                change becoming effective and update the &quot;Last updated&quot; date at the top of this Privacy
                Policy.</p><p>You are advised to review this Privacy Policy periodically for any changes. Changes to
                this Privacy Policy are effective when they are posted on this page.</p><h1>Contact Us</h1><p>If you
                have any questions about this Privacy Policy, You can contact us:</p>
            <ul>
                <li>By email: <a  href="javascript:" onClick={cfDecodeEmail} className="_cf_email_"
                                 >[email&#160;protected]</a></li>
            </ul>
            <h2>Deleting your account</h2>

            <p>If you would like to delete your data, you can do so simply by logging in and going to
                https://www.politiq.net/settings then clicking Account. There you will see a button "Delete my account".
                This will remove all personal information from our site and all your posts and comments. </p>

        </div>,
        205: "Sorry, you can only add 7 tags per post.",
        206: "Sorry, you can not comment on this post.",
        207: "view all",
        208: "This audience has no members yet.",
        209: "First Select Audiences For Your Posts and comments: Who can see them",
        210: "Voter Location Setting",
        211: "Still not sure about adding your home address? Watch this video. ",
        212: "Add Second Voter Location",
        213: "Yup, that's me",
        214: "Voter Locations",
        215: "Privacy",
        216: "Account",
        217: "Reply in private",
        218: "Reply in group...",
        219: "Reply in public",
        220: "Upload Avatar",
        221: "Source image:",
        222: "Latest Votes",
        223: <div><b>Yes</b>, think long and hard about your username, because you won't be able to change it. But don't worry, we'll mainly use your display name to mention you and show your name to other people.</div>,
        224: "Pretty self-explanatory, we hope.",
        225: "Make sure you provide a strong enough password. You know, some caps, some special characters, a couple of numbers.",
        226: "You'd be surprised how many robots try to sign up here. We only accept people. Click the checkbox because, somehow, only people know how to do this.",
        227: "Vote",
        228: "View Profile",
        229: "Login with Facebook ",
        230: "Login with Twitter",
        231: "Sign Up with Facebook",
        232: "Sign Up with Twitter",
        233: "or...",
        234: "YESTERDAY SCORE",
        235: "Thank you, check your inbox for activation mail",
        236: "Back to Login",
        237: "Send",
        238: "Support Us ",
        239: "Support Us coming soon",
        240: "Founding Members",
        241: "Your official vote was cast",
        242: "Votes",
        243: "This is my official position on this ",
        244: "party ",
        245: "person ",
        246: "Only show official votes",
        247: "There are no public votes or comments yet. Feel free to be the first!",
        248: "Undecided...",
        249: "Latest Comments",
        250: "Terms of Use",
        251: <div><p>So glad you're reading this. We're gonna work together, so we need to just be clear on a few things.
        We're gonna do our best to ensure your security and privacy. We're not gonna sell your data or show you ads.
          We're all about a healthy political discussion. And from you, all we ask is a few things:</p>
            <ul>
                <li>- You are who you say you are (though no one will need to know who you really are. We will protect
                your identity online)
              </li>
                <li>- You are not here to sell or promote products, services, or lifestyles, etc
              </li>
                <li>- You are here to discuss politics as well as social and economic issues. Posting things unrelated to
                these topics (vacation pics, cat pics, etc) is against our policy
              </li>
                <li>- You can have any political views you want as long as you are a good person who is respectful to
                others and is here to make the world a better place. Geez, that is vague! We know that deciding on the
                basis of your activity if you are a "good person" is practically a philosophical question. What is a
                good person? Maybe it's not just being respectful that makes you good. Maybe it's good to argue for
                the truth even if it hurts others. It will be a long process to come to anything satisfactory, and bet
                your bottom dollar that we'll never make everyone happy with our policies, but philosophically
                speaking, that's life. Digital life isn't any easier.
              </li>
            </ul>
            <p>So, if you don't follow the rules, we reserve the right to...you know, kick you out.</p>
            <p>It's all in the name of providing the best experience for as many people as possible and progressing
              society, etc, etc, etc. Are we square? Great. Now get busy!</p>
        </div>,
        252: "I'm voting for",
        253: "By signing up you agree to the",
        254: "Aggregation Jobs",
        255: "Unauthorized",
        256: "Admin",
        257: "Activity",
        258: "Users",
        259: "Goals",
        260: "Who can see this Goal",
        261: "Who can comment on this Goal",
        262: "Goals List",
        263: "Goal info",
        264: "Location",
        265: "Privacy settings",
        266: "Pictures and tags",
        267: "No goals are here... yet.",
        268: "Thank You.",
        269: "Pending moderator's approval",
        270: "Orgs",
        271: "Send invitation",
        272: "be the first to comment on this person",
        273: "be the first to comment on this party",
        274: "sorry, your reputation level isn't high enough for that action",
        275: "Sorry, your Reputation Level is not high enough to do this",
        276: "Sorry, your Reputation Level is not high enough to comment on this public post",
        277: "please enter strong password ....The string must contain at least 1 lowercase alphabetical character ,1 uppercase alphabetical character,1 numeric character, 1 special character and The string must be eight characters or longer",
        278: "This account has been banned.",
        279: "Sorry, you aren’t allowed to post any more today",
        280: "Anonymous mode",
        281: "Ok",
        282:<div><h6>Welcome to Anonymous Mode </h6><br/><p>No one will know it is you when you post. But negative interactions will still count against your Reputation Level, so keep the quality high and the tone respectful.</p></div>,
        283:<div><p>Exiting Anonymous Mode</p></div>,
        284: "Anonymous User",
        285: "You can vote at any time!",
        286: "Why wait every couple of years to vote? Let's start a new system of accountability here. We need more frequent and innovative ways to show our leaders how we feel. Gamified voting is just the start.",
        287:<div><h5>We are</h5><h2>The New Kid in Town</h2><p>A new social platform dedicated to politics. We're taking the good ingredients from the current set of social networks and adding a few new ones to make a unique experience. We're just getting started and welcome your feedback for improvements and what you want more of.</p></div>,
        288:<div><h5>Anonymous but Real</h5><p>You don't have to reveal your name or location on the site. But you do need to be a real person. The system knows who you really are, but you're free to wear a mask online.</p></div>,
        289:<div><h5>Global but Intimate</h5><p>Talking politics with strangers may not be for you. The site let's you talk more intimately to friends and followers.</p></div>,
        290:<div><h5>Integrated Political Data</h5><p>Your politicians, government officials, elections and their candidates will all be natively integrated into the site. They're automatically a part of the experience.</p></div>,
        291: "FAQs",
        292: "George Washington",
        293: "A primary object should be the education of our youth in the science of government. In a republic, what species of knowledge can be equally important? And what duty more pressing than communicating it to those who are to be the future guardians of the liberties of the country?",
        294: "Nothing showing? Go to the members page and see who is interesting to follow",
        295: "Custom",
        296: "Male",
        297: "Female",
        298: "Gender",
        299: "Refer to me as",
        300: "she/her/hers",
        301: "he/him/his",
        302: "they/them/their",
        303: "Select Here",
        304: "Text Here",
        305: "We're in private beta at the moment, but you can sign up for the newsletter here.",
        306: "*Indicates Required",
        307: "Email*",
        308: "First Name*",
        309: "Last Name*",
        310: "Are you sure to delete this comment?",
        311: "Please upload a file smaller than 5 MB",
        312: "Everyone",
        313: "Who will see this post",
        314:<legend className="cdw">Who can comment on this post<span className="explain cdw">(obviously they must first be able to see it)</span></legend>,
        315: "Posted Anonymously",
        316: "Mission",
        317: "Features",
        318: "Sorry, you've reached your post limit for the day, please try again tomorrow",
        319: "Sorry, your Reputation Level is not high enough to post on the site. Check your settings to make sure your profile, avatar, and voter location are filled",
        320: "Sorry, your Reputation Level is not high enough to comment on the site",
        321: "sorry, you've reached your comment limit for the day, please try again tomorrow",
        322: "No One",
        323:<div className="cdw">Want to change these settings globally?<Link to={{ pathname:"/settings",state:{tabId:3}}}> Click here</Link></div>,
        324: "Comments are turned off for this post",
        325: "This Post and comments: Who can see them",
        326:<legend className="cdw">This Post and comments: Who can comment on them <span className="explain cdw">(obviously they'll have to be able to read them)</span></legend>,
        327: "Maximum limit reached",
        328: "Sorry, you can only have 7 tags per post. If you add a new one it will replace the last one.",
        329: "The two passwords don't match! Please make sure they are the same.",
        330: "You're in!",
        331: "Congratulations! You have successfully signed-up. Click ok to fill in your profile.",
        332: "Please enter a password for your new account",
        333: "Oops. Make sure you choose thumbs-up, down, or undecided!",
        334: "Enter an email address and password to signup",
        335: "Either comment is deleted or not found here",
        336: "Either page is deleted or not found here",
        337: "Topic Stance",
        338: "Sorry, your user level isn’t high enough to report abuse",
        339: "New Topic Stances",
        440: "You can add a topic language",
        441: "go ahead spill your guts!",
        442: "No topic stances are here... yet.",
        443: "Edit Topic Stances",
        444: "No topic stances are here... yet.",
        445: "Who will see this topic stance",
        446:<legend className="cdw">Who can comment on this topic stance<span className="explain cdw">(obviously they must first be able to see it)</span></legend>,
        447: "Something went wrong",
        448: "You have already created a topic stance for this topic. You need to click the button below to edit.",
        449: "This topic stance was saved in Dutch but this one will be saved in English. If you are ok with that, please rewrite the topic stance in English. Otherwise, switch the site language and reopen this page.",
        450: "This topic stance was saved in English but this one will be saved in Dutch. If you are ok with that, please rewrite the topic stance in Dutch. Otherwise, switch the site language and reopen this page.",
        451: "Edit Topic Stance",
        452: "take a stance",
        453: "Stances On",
        454: "Are you sure you want to delete this topic stance?",
        455: "Topic Stance Removed Successfully.",
        456: "Remove",
        457: "Show more",
        458: "Abuse",
        459: "HangFire",
        460: "This is what i think of that...",
        461: "Login to comment...",
        462: "Hot Topics",
        463: "IN THEIR OWN WORDS",
        464: "Politiq is owned by You",
        465: "Social media is important - its goal can’t be profit. Put the town square in the hands of the people and it won’t be. Politiq aims to be a Public Trust owned by you. This platform was created to offer a safe, thought-provoking environment to exchange discourse in a respectful way…but together, no matter what side you’re on.",
        466: "It’s a balancing act. There is no fool-proof solution. Users will be verified, but we need to allow them to be anonymous. A Reputation System ensures that everyone acts as they would in a small in-person group – not hiding behind the shield of a screen. Misinformation needs to go under the microscope, and what is true and what is false cannot be determined by a small group of people with their own inherent biases. It must be determined by all of us with the help of smart systems.",
        467: "Free speech",
        468: <h4>How to protect <span className="label-pink">free speech</span> but
            maintain <span className="label-pink">safety</span>? What
            about <span className="label-white">misinformation?</span>
        </h4>,
        469: "Daily votes and Topic Stances",
        470: "The more complicated the world gets and the more conflicting sources of info there are, the more we need to rely on those we trust. Tell us who you’re voting for and where you stand on the issues.",
        471: "We are the New Kid in Town",
        472: "A new social platform dedicated to politics. We're taking the good ingredients from the current set of social networks and adding a few new ones to make a unique experience. We're just getting started and welcome your feedback for improvements and what you want more of.",
        473: "Politiq Values",
        474: <div><p>Everything human needs values. Companies, governments, sports teams, religions, organizations, families and individual humans themselves. And of course, social media platforms like Politiq.</p><p>Now, we have a mission statement. Which is:<br/><b><i>To improve the quality and effectiveness of political action, towards the goal of the highest prosperity for the most people.</i></b></p><p>Implicit in this mission is a set of values. Yes, I always thought this kind of talk was boring too, but it needs to happen. If you’re going to be investing your time here, it’s important for you to know what we’re all about.</p>
          <p><b>Prosperity</b>. It is the main goal of humanity and we support people in attaining that goal</p><p><b>Love</b>. Call it corny, but it’s the best feeling in the world. We understand that you will love family and friends more than others. It’s ok.</p><p><b>Freedom</b>. You have to be you, otherwise what’s the point of all this? What’s more, we understand that you need to express it to the rest of the world.</p><p><b>Honesty</b>. We believe this will lead to more prosperity in the long run, even at the detriment of short term prosperity.</p><p><b>Empathy</b>. Much of life is suffering. Let’s help each other through it and empathize with everyone’s struggles.</p>
          <p><b>Civility</b>. It’s not just what you say, but how you say it. Saying it well shows respect.</p><p><b>Focus</b>. Information is integral to our being. Some of it is important, but most of it is a distraction.</p><p><b>Accuracy</b>. Let’s accept that while the truth is complicated, some things are true and some are not.</p>
        </div>,
        475: "Migrating from Twitter",
        476: <div><p>In principle, many people want to leave Twitter but find it difficult because they don’t want to lose the investment they have put in. For all the talk of Twitter being a town square, it is largely a marketing platform. Via ads or just incessant tweeting, many many Twitter members are ultimately trying to sell you something. The more followers they have, the more warm leads they have. It’s worth something and they don’t want to throw it away. On top of that is the social status that comes with a large following. It would be one thing if you had all these warm leads and only you knew about it, but with your number of followers prominently displayed by your profile, it has become a status symbol.</p>
          <p>Politiq wants to make it worth your while to join our platform. Since Twitter owns your set of followers, we can’t migrate them over to Politiq. So, we those warm leads will have to stay on Twitter. But we can do something related to the social status you have built up there. Because we have a version of social status too: Reputation Level.</p><p>What we will offer is the following:<br/>Sign up via the Twitter login button on Politiq and we will upgrade your Reputation Level for the first 9 months on the site. Upgrade it to what? Good question. Depending on the number of followers you have on Twitter, we will set your Reputation Level to the value corresponding to your tier listed in the table below. Get a Reputation Level of x and it will remain at least that for 9 months. After that period, the Reputation System will kick in and give you what you would normally get based on your activity from the past 9 months.</p>
          <p>As you may have read, just fill in your profile and voter location and you automatically get a Reputation Level of 2 on the site. So, the numbers below are what we add on top of that.</p>
          <table border='1' className='migrating-table'>
            <thead><tr>
              <th>Nr of followers</th>
              <th>Extra points</th>
            </tr></thead>
            <tbody><tr>
              <td>0-100</td>
              <td>0</td>
            </tr>
            <tr>
              <td>101-1000</td>
              <td>1</td>
            </tr>
            <tr>
              <td>1001-10000</td>
              <td>2</td>
            </tr>
            <tr>
              <td>10001-50000</td>
              <td>3</td>
            </tr>
            <tr>
              <td>50001-100000</td>
              <td>4</td>
            </tr>
            <tr>
              <td>100K +</td>
              <td>5</td>
            </tr>
            </tbody>
          </table>
          <p>Caveats: This only applies if you have an account dedicated to politics, social, or economic issues, or are in the news media. You’ll still be subject to the terms of the site. Anyone structurally in breach of the terms will be removed.</p>
          </div>,
          477: "Enter Email And Password",
          478: "Email Already Exist",
          479: "Internal Server Error",
          480: "description",
          481: "Related Organization",
          482: "Either your Display Name or Display Location is empty in your profile. Please fill it in before you follow anyone. ",
          483:"Chat with",
          484:"Here you can chat with",
          485:"Here comes a little disclaimer text and all",
          486:"These texts need to be in the language files.",
          487:"New Question",
          488:"Chat",
          489:"Digital",
          490:"Chat in",
          491: "This is not real. And it's not official, either. For now, it's just an experiment - hopefully a fun one, even an educational one, where we see if we can bring the masses closer to political experts and to their elected officials. We will look to share your chats with the Polly you're chatting with. Just as your posts and comments on Politiq, keep it positive. And be a part of the circle of learning and teaching.",
          492: "Start a new conversation",
          493: "Is this you?",
          494: "Want to take control of your page?",
          495: "We have 2 options:",
          496: "1.	Sign up with Twitter/X (if you are “Twitter/X Verified”).",
          497: "Within 48 hours, we will have your page assigned to your new Politiq account",
          498: "-- OR --",
          499: "2. Sign up with email using an email address from your official website domain.",
          500: "",
          501:"SIGN UP WITH TWITTER"
    }, NL: {
        0: "Voor het politieke dier",
        1: "E-mail",
        2: "Wachtwoord*",
        3: "Onthoud mij",
        4: "Inloggen",
        5: "Nog geen lid? Klik hier",
        6: "Wachtwoord vergeten?",
        7: "Gebruikersnaam (geen spaties, alstublieft.)",
        8: "Voornaam (Ja, uw echte voornaam)",
        9: "Achternaam (zelfde als hierboven)",
        10: "Schermnaam (wat de wereld ziet)",
        11: "Inschrijven",
        12: "Politiek",
        13: "U staat op het punt naar de forums te gaan waar u de site zelf kunt bespreken. De forums gebruiken Disqus waarvoor een externe aanmelding is vereist, dus als je wilt deelnemen, moet je je daar aanmelden.",
        14: "Doorgaan met",
        15: "Over ons",
        16: "Contact",
        17: "Privacybeleid",
        18: <h2>This all depends on
          <span className="title-accent">your </span>
            <span className="title-accent-more">participation!</span>
            <span className="itallic text-right">Barack Obama</span></h2>,
        19: <div className="contenttext">
            <h2 className="red">We're the new kid in town</h2>
            <p>Een nieuw sociaal platform gewijd aan de politiek. We nemen de goede ingrediënten uit de huidige set sociale netwerken en voegen een paar nieuwe toe om een unieke ervaring te maken. We zijn net begonnen, dus dit is nog maar het begin.</p>
        </div>,
        20: "Het gaat allemaal over",
        21: "Vakantiefoto's zijn inderdaad leuk, maar niet hier. Je bent hier om de wereld te veranderen. En je doet dat door te praten over politiek en stemmen en interactie met politici. Maak je geen zorgen, we zullen je echte identiteit verborgen houden, zodat je je vrij kunt voelen om te spreken.",
        22: "Geen advertenties",
        23: "We maken deel uit van de natuurlijke verschuiving weg van op advertenties gebaseerde bedrijfsmodellen. Geen advertenties, geen datamining, geen manipulatie. U bent de consument, niet het product. We zullen uiteindelijk een minimale vergoeding vragen om deel te nemen op de site, die per land in verhouding is met de GDP per capita in je land. Ja, het is vervelden om voor dingen te betalen, maar het is nog erger om gemanipuleerd te worden is nog erger. Gebruik je kracht en betaal voor de site. Je hebt pas controle als je betaald.",
        24: "Twitter te hard? Facebook nep?",
        25: "We proberen hier een vriendelijker, constructiever forum te creëren. Anonimiteit zonder gevolgen is een recept voor een ramp. Laten we een reputatie toevoegen aan de mix. En het is tijd voor intimiteit in onze discussie, omdat praten met iedereen in de wereld op hetzelfde moment zal leiden tot neppe of vijandige discussies. Geen van beiden zal helpen. Laten we kijken of we wat knoppen kunnen klikken voor een beter geluid.",
        26: "Goals",
        27: "Geen woorden, maar daaden. Maak doelen en laat de community actie ondernemen rond die doelen.",
        28: "Anoniem maar echt",
        29: "U hoeft uw naam of locatie niet op de site te vermelden. Maar je moet wel een echt persoon zijn. Het systeem weet wie je echt bent, maar je bent vrij om een masker online te dragen.",
        30: "Wereldwijd maar intiem",
        31: "Praten met vreemdelingen is misschien niet voor jou. Op deze site kunt u intiemer met vrienden en volgers praten.",
        32: "Geïntegreerde politieke gegevens",
        33: "Uw politici, overheidsfunctionarissen, verkiezingen en hun kandidaten worden allemaal op de site geïntegreerd. Ze maken automatisch deel uit van de ervaring.",
        34: <span><h2>U kunt op elk moment stemmen!</h2><p>Waarom zou je om de paar jaar wachten om te stemmen? Laten we hier een nieuw systeem van verantwoordelijkheid beginnen. We hebben meer frequente en innovatieve manieren nodig om onze leiders te laten weten wat we van ze vinden. Fake voting is nog maar het begin.</p></span>,
        35: <span><h2 className="text-white">The opposite</h2><p className="text-white">Laten we het tegenovergestelde proberen: gebruik een andere reeks incentives om een kwaliteitsgesprek te maken en een andere reeks hulpmiddelen om actie te ondernemen. En laten we het financiële motivatie wijzigen om de gebruikers in de leiding te zetten. Hoe is dat voor anders !?</p></span>,
        36: "2019 Politiq Alle rechten voorbehouden",
        37: "Blog",
        38: "Community",
        39: "Pollies",
        40: "nieuwe",
        41: "leden",
        42: "Huis",
        43: "Mijn spullen",
        44: "instellingen",
        45: "Doelgroepen",
        46: "uitloggen",
        47: "Welkom",
        48: "Wat wil je met ons delen vandaag?",
        49: "U kunt een titel toevoegen als u wilt",
        50: "Gooi het er maar uit! Vergeet niet de gerelateerde politici, organisaties, landen, en onderwerpen te taggen.",
        51: "Privacy instellingen",
        52: "Volledige post",
        53: "Publiceren",
        54: "tags toevoegen",
        55: "Mijn pollies",
        56: "Aankomende verkiezingen",
        57: "Alles zien",
        58: <div>We hebben 3 knoppen om uit te kiezen. Je kunt privé antwoorden, zodat alleen de auteur je reactie kan zien. Je kunt op je vrienden reageren zodat alleen je vrienden je reactie of de hele wereld kunnen zien, zodat iedereen deze kan zien.<br />Reply in Private is natuurlijk de coolste, dus bekijk de video om meer te zien waar dat over gaat.</div>,
        59: "Schrijf een reactie...",
        60: "Privé",
        61: "Groep",
        62: "Openbaar",
        63: "beantwoorden",
        64: <div>Plaats alle artikelen of gedachten die je hebt gerelateerd aan de politiek. Dit lijkt veel op andere sociale netwerken, maar nog steeds een beetje uniek. Hier zijn enkele van de functies: <ul><li>- plak een URL om een voorbeeld van de link te tonen</li><li>- voeg een titel toe, als je wilt</li><li>- klik op Privacy-instellingen om niet alleen te selecteren wie een bericht kan zien, maar ook wie er op kan reageren</li><li>- klik op Volledige post om een extra veld Beschrijving te krijgen, waarmee u de post voor bepaalde overzichten kunt samenvatten</li><li> - in de Volledige berichtmodus kunt u ook Opslaan als Concept</li><li>- Tags en / of afbeeldingen toevoegen aan een bericht (als u een polly tagt, wordt uw bericht ook weergegeven op hun pagina voor degenen die het kunnen bekijken</li></ul></div>,
        65: "Posten op Politiq",
        66: "Bezig met laden",
        67: "Verwijder deze draft",
        68: "Nieuw bericht",
        69: "Waar gaat dit bericht over? Ik vat het hier samen.",
        70: "Mijn berichten en opmerkingen: wie kan ze zien",
        71: "Geselecteerde doelgroep",
        72: "Alleen vrienden",
        73: "Vrienden en volgers (en alle anderen die luisteren)",
        74: <legend className="cdw">Mijn berichten en opmerkingen: wie kan er commentaar op geven <span className="explain cdw">(ze zullen ze uiteraard moeten kunnen lezen)</span></legend>,
        75: "Post publiceren",
        76: "Opslaan als concept",
        77: "Naam",
        78: "Alleen de politicus in kwestie",
        79: "U hebt geen doelgroepen gedefinieerd om deze optie te gebruiken. Als je ze wilt maken voor dit bericht, sla dit dan op als een concept (in de Volledig modus) en ga vervolgens naar de pagina Doelgroepen om doelgroepen te maken.",
        80: "Sluiten",
        81: "Foto uploaden",
        82: "bestand is gekozen",
        83: "Kies bestanden om te uploaden",
        84: "afbeeldingen toevoegen",
        85: "helpen",
        86: "man",
        87: "vrouw",
        88: "Niet meer volgen",
        89: "U volgd deze persoon",
        90: "Volgen",
        91: "Niet meer nauw volgen",
        92: "U volgd deze persoon nauw",
        93: "Nauw volgen",
        94: "Zoeken",
        95: "Politici waar je op stemt",
        96: "Klik om ze in het nieuws te zien",
        97: "Laat hen weten wat je van ze vind",
        98: "Delen op Facebook",
        99: "Delen op Twitter",
        100: "jij stemde",
        101: "Hoe voel je je over hen vandaag?",
        102: "Nee, dank u wel",
        103: "Annuleer",
        104: "kan dit zien",
        105: "Wie kan dit zien?",
        106: "voorleggen",
        107: "Ik heb net ONLINE gestemd voor",
        108: "Het telt niet, maar reken op mij om het in echt te doen bij de volgende verkiezing.",
        109: "Wilt u dat verder uitleggen?",
        110: "Capaciteit",
        111: "Visie",
        112: "Op Politiq kun je politici en overheidsfunctionarissen bekijken (of, pollies, zoals we ze noemen). Er zijn twee smaken: standaard volgen en nauw volgen. Als je ze nauw volgd, betekent dit dat je een e-mail notificatie krijgt als ze op Politiq posten. Misschien wilt u meteen weten of bepaalde pollies berichten plaatsen en nauw willen volgen zodat u snel op de hoogte blijft. Normaal volgen houdt gewoon in dat hun berichten worden weergegeven in uw feed. Je krijgt geen aparte e-mail over hun berichten. \n En hier kunt u elke dag stemmen op de pollies die u belangrijk vind (en die waarvan u wilt dat het beter ging). Verplaats de twee schuifregelaars naar het gewenste niveau en klik op Verzenden. Uw goede daad is vandaag gedaan, maar u kunt morgen opnieuw stemmen.",
        113: "Wellicht is er geen verkiezing, maar u kunt hier elke dag stemmen!",
        114: "Score van gisteren: Vision:",
        115: "op ",
        116: "Bedankt voor uw stem vandaag, u kunt morgen opnieuw stemmen",
        117: "stemmen",
        118: "People's Voice",
        119: "Wees de eerste om op deze persoon te reageren",
        120: "commentaar geven",
        121: "In het nieuws",
        122: "3 minuten geleden.",
        123: "Er zijn geen nieuwsberichten te zien",
        124: "Gerelateerde pollies",
        125: "Voeg nieuw publiek toe",
        126: "Stel deze doelgroep in als mijn standaardpubliek.",
        127: "Doelgroepnaam",
        128: "Toevoegen",
        129: "Doelgroepen zijn een manier om te beperken wie je berichten ziet. Maak hier een doelgroep, voeg er vrienden aan toe en selecteer vervolgens een of meer doelgroepen in de Privacyinstellingen van een bericht. Alleen de leden van het publiek zullen de post zien. Wil je dit allemaal leren in een video? Bekijken:",
        130: "Bewerk",
        131: "Verwijder",
        132: "Mijn vrienden",
        133: "kandidaten",
        134: "Comments",
        135: "Gerelateerde verkiezingen",
        136: "Verkiezingen bij u in de buurt",
        137: "Vraag om reset email",
        138: "wachtwoord bevestigen",
        139: "Posts",
        140: "Vrienden",
        141: "Volgt",
        142: "Wordt vervolgd door",
        143: "Niet meer volgen",
        144: "Niet meer nauw volgen",
        145: "U volgd nauw",
        146: "Nauw volgen",
        147: "Niet meer volgen",
        148: "U volgd",
        149: "Volgen",
        150: "Niet meer nauw volgen",
        151: "U volgd nauw",
        152: "Nauw volgen",
        153: "vrouwelijk",
        154: "mannelijk",
        155: "Citaat",
        156: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.",
        157: "Verder lezen",
        158: "Claim deze pagina",
        159: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris pellentesque volutpat mauris et sodales. Cras et enim dapibus, sodales lacus et, sodales elit.",
        160: "Wellicht is er geen verkiezing, maar u kunt hier elke dag stemmen!",
        161: "Sta deze persoon toe om mij e-mails / directe berichten te sturen",
        162: "Nieuws",
        163: "Commentaar",
        164: "Prive bericht",
        165: "antwoordde",
        166: "Sorry, u heeft geen toegang tot deze pagina.",
        167: "Bericht bewerken",
        168: "Verwijder bericht",
        169: "Verwijder bericht...",
        170: "door",
        171: "Open",
        172: "Verder schrijven",
        173: "Op Politiq kun je andere mensen volgen, of ... nauw volgen. Nauw volgen betekent alleen dat u een e-mailmelding krijgt als ze op Politiq posten. Het idee is dat je direct van sommige mensen wilt horen. Nauw volgen is de manier om dat te doen. Normaal volgen betekent alleen dat hun berichten worden weergegeven in uw feed. Je krijgt geen aparte e-mail over hun berichten.",
        174: "Bewerk profielinstellingen",
        175: "Mijn posts",
        176: "Favoriete berichten",
        177: "Jij bent het echt! Top! Uw account is geactiveerd. Klik alstublieft inloggen om dat te doen. Dan graag je profiel invullen om te starten met een Reputatie Niveau van 2.",
        178: "Gebruikersnaam",
        179: "Bedankt, kijk in uw e-mail voor een activatiemail. (Misschien zit het in je SPAM box...)",
        180: "Voornaam",
        181: "Achternaam",
        182: "nieuw paswoord",
        183: "Verwijder mijn account",
        184: "Update-instellingen",
        185: "Preview:",
        186: "OMG, ik zie er geweldig uit!",
        187: "Mijn profiel - wie kan het zien / vinden",
        188: "De hele wereld",
        189: "Wie kan mij een direct bericht sturen",
        190: "Mijn berichten en opmerkingen: wie kan er commentaar op geven (ze zullen ze uiteraard moeten kunnen lezen)",
        191: "Mijn stemmen: wie kan ze zien",
        192: "Je naam zoals mensen het zullen zien",
        193: "Vertel ons waar je bent (of waar je wilt zijn)",
        194: "dat zeg ik liever niet",
        195: "Uw profiel",
        196: "Uw instellingen",
        197: "Vul hier uw thuisadres in. Begin gewoon je straatadres te typen totdat het volledige adres gevuld wordt. We hebben het nodig om u te kunnen matchen met politici en verkiezingen, enz. We zullen nooit contact met u opnemen of iemand deze informatie laten weten (zelfs niet op de site!)",
        198: "Poli-wie-dan?",
        199: "",
        200: "Account verwijderd",
        201: "Neem contact met ons op",
        202: "Voor nu, het beste om ons te bereiken via e-mail: writeme [apenstaartje] politiq.net",
        203: "Privacybeleid (hint, het is niet zo erg)",
        204: <div><p>Last updated: December 02, 2021</p><p>This Privacy Policy describes Our policies and procedures on
            the collection, use and disclosure of Your information when You use the Service and tells You about Your
            privacy rights and how the law protects You.</p><p>We use the voter location data you provide to show you
            relevant political and governmental data. By using the Service, You agree to us storing that information in
            our system in accordance with this Privacy Policy. This voter location data is not shared with other users
            of the service, nor is any other actual personal information you enter on the site.</p><h1>Interpretation
            and Definitions</h1><h2>Interpretation</h2><p>The words of which the initial letter is capitalized have
            meanings defined under the following conditions. The following definitions shall have the same meaning
            regardless of whether they appear in singular or in plural.</p><h2>Definitions</h2><p>For the purposes of
            this Privacy Policy:</p>
            <ul>
                <li><p><strong>Account</strong> means a unique account created for You to access our Service or parts of
                    our Service.</p></li>
                <li><p><strong>Company</strong> (referred to as either &quot;the
                    Company&quot;, &quot;We&quot;, &quot;Us&quot; or &quot;Our&quot; in this Agreement) refers to
                    Politiq, Hoekveen 3, Hooglanderveen, The Netherlands.</p></li>
                <li><p><strong>Cookies</strong> are small files that are placed on Your computer, mobile device or any
                    other device by a website, containing local bit of personal data used to facilitate a improved
                    working of the website.</p></li>
                <li><p><strong>Country</strong> refers to: Netherlands</p></li>
                <li><p><strong>Device</strong> means any device that can access the Service such as a computer, a
                    cellphone or a digital tablet.</p></li>
                <li><p><strong>Personal Data</strong> is any information that relates to an identified or identifiable
                    individual.</p></li>
                <li><p><strong>Service</strong> refers to the Website.</p></li>
                <li><p><strong>Service Provider</strong> means any natural or legal person who processes the data on
                    behalf of the Company. It refers to third-party companies or individuals employed by the Company to
                    facilitate the Service, to provide the Service on behalf of the Company, to perform services related
                    to the Service or to assist the Company in analyzing how the Service is used.</p></li>
                <li><p><strong>Third-party Social Media Service</strong> refers to any website or any social network
                    website through which a User can log in or create an account to use the Service.</p></li>
                <li><p><strong>Usage Data</strong> refers to data collected automatically, either generated by the use
                    of the Service or from the Service infrastructure itself (for example, the duration of a page
                    visit).</p></li>
                <li><p><strong>Website</strong> refers to Politiq, accessible from <a href="https://www.politiq.net/"
                                                                                      target="_blank">https://www.politiq.net/</a>
                </p></li>
                <li><p><strong>You</strong> means the individual accessing or using the Service, or the company, or
                    other legal entity on behalf of which such individual is accessing or using the Service, as
                    applicable.</p></li>
            </ul>
            <h1>Collecting and Using Your Personal Data</h1><h2>Types of Data Collected</h2><h3>Personal Data</h3>
            <p>While using Our Service, We may ask You to provide Us with certain personally identifiable information
                that can be used to contact or identify You. Personally identifiable information may include, but is not
                limited to:</p>
            <ul>
                <li><p>Email address</p></li>
                <li><p>First name and last name</p></li>
                <li><p>Address, State, Province, ZIP/Postal code, City</p></li>
                <li><p>Usage Data</p></li>
            </ul>
            <h3>Usage Data</h3><p>Usage Data is collected automatically when using the Service.</p><p>Usage Data may
                include information such as Your Device's Internet Protocol address (e.g. IP address), browser type,
                browser version, the pages of our Service that You visit, the time and date of Your visit, the time
                spent on those pages, unique device identifiers and other diagnostic data.</p><p>When You access the
                Service by or through a mobile device, We may collect certain information automatically, including, but
                not limited to, the type of mobile device You use, Your mobile device unique ID, the IP address of Your
                mobile device, Your mobile operating system, the type of mobile Internet browser You use, unique device
                identifiers and other diagnostic data.</p><p>We may also collect information that Your browser sends
                whenever You visit our Service or when You access the Service by or through a mobile device.</p>
            <h3>Information from Third-Party Social Media Services</h3><p>The Company allows You to create an account
                and log in to use the Service through the following Third-party Social Media Services:</p>
            <ul>
                <li>Facebook</li>
                <li>Twitter</li>
            </ul>
            <p>If You decide to register through or otherwise grant us access to a Third-Party Social Media Service, We
                may collect Personal data that is already associated with Your Third-Party Social Media Service's
                account, such as Your name, and Your email address associated with that account.</p><p>You may also have
                the option of sharing additional information with the Company through Your Third-Party Social Media
                Service's account. If You choose to provide such information and Personal Data, during registration or
                otherwise, You are giving the Company permission to use, share, and store it in a manner consistent with
                this Privacy Policy.</p><h3>Tracking Technologies and Cookies</h3><p>We use Cookies and similar tracking
                technologies to track the activity on Our Service and store certain information. Tracking technologies
                used are beacons, tags, and scripts to collect and track information and to improve and analyze Our
                Service. The technologies We use may include:</p>
            <ul>
                <li><strong>Cookies or Browser Cookies.</strong> A cookie is a small file placed on Your Device. The
                    only information stored in cookies to allow for automatic signin from your device. To that effect,
                    when you click "Remember me" at login, you are effectively accepting the use of cookies for this
                    purpose.
                </li>
            </ul>
            <ul>
                <li><p><strong>Functionality Cookies</strong></p><p>Type: Persistent Cookies</p><p>Administered by:
                    Us</p><p>Purpose: These Cookies allow us to remember choices You make when You use the Website, such
                    as remembering your login details or language preference. The purpose of these Cookies is to provide
                    You with a more personal experience and to avoid You having to re-enter your preferences every time
                    You use the Website.</p></li>
            </ul>
            <h2>Use of Your Personal Data</h2><p>The Company may use Personal Data for the following purposes:</p>
            <ul>
                <li><p><strong>To provide and maintain our Service</strong>, including to monitor the usage of our
                    Service.</p></li>
                <li><p><strong>To manage Your Account:</strong> to manage Your registration as a user of the Service.
                    The Personal Data You provide can give You access to different functionalities of the Service that
                    are available to You as a registered user.</p></li>
                <li><p><strong>To contact You:</strong> To contact You by email, SMS, or other equivalent forms of
                    electronic communication, such as a mobile application's push notifications regarding updates or
                    informative communications related to the functionalities, products or services, including the
                    security updates, when necessary or reasonable for their implementation.</p></li>
                <li><p><strong>To provide You</strong> with news, special offers and general information about other
                    goods, services and events which we offer that are similar to those that you have already purchased
                    or enquired about unless You have opted not to receive such information.</p></li>
                <li><p><strong>For other purposes</strong>: We may use Your information for other purposes, such as data
                    analysis, identifying usage trends, determining the effectiveness of our promotional campaigns and
                    to evaluate and improve our Service, products, services, marketing and your experience.</p></li>
            </ul>
            <h2>Retention of Your Personal Data</h2><p>The Company will retain Your Personal Data only for as long as is
                necessary for the purposes set out in this Privacy Policy. We will retain and use Your Personal Data to
                the extent necessary to comply with our legal obligations (for example, if we are required to retain
                your data to comply with applicable laws), resolve disputes, and enforce our legal agreements and
                policies.</p><p>The Company will also retain Usage Data for internal analysis purposes. Usage Data is
                generally retained for a shorter period of time, except when this data is used to strengthen the
                security or to improve the functionality of Our Service, or We are legally obligated to retain this data
                for longer time periods.</p><h2>Transfer of Your Personal Data</h2><p>Your information, including
                Personal Data, is processed at the Company's operating offices and in any other places where the parties
                involved in the processing are located. It means that this information may be transferred to — and
                maintained on — computers located outside of Your state, province, country or other governmental
                jurisdiction where the data protection laws may differ than those from Your jurisdiction.</p><p>Your
                consent to this Privacy Policy followed by Your submission of such information represents Your agreement
                to that transfer.</p><p>The Company will take all steps reasonably necessary to ensure that Your data is
                treated securely and in accordance with this Privacy Policy and no transfer of Your Personal Data will
                take place to an organization or a country unless there are adequate controls in place including the
                security of Your data and other personal information.</p><h2>Disclosure of Your Personal Data</h2>
            <h3>Law enforcement</h3><p>Under certain circumstances, the Company may be required to disclose Your
                Personal Data if required to do so by law or in response to valid requests by public authorities (e.g. a
                court or a government agency).</p><h3>Other legal requirements</h3><p>The Company may disclose Your
                Personal Data in the good faith belief that such action is necessary to:</p>
            <ul>
                <li>Comply with a legal obligation</li>
                <li>Protect and defend the rights or property of the Company</li>
                <li>Prevent or investigate possible wrongdoing in connection with the Service</li>
                <li>Protect the personal safety of Users of the Service or the public</li>
                <li>Protect against legal liability</li>
            </ul>
            <h2>Security of Your Personal Data</h2><p>The security of Your Personal Data is important to Us, but
                remember that no method of transmission over the Internet, or method of electronic storage is 100%
                secure. While We strive to use commercially acceptable means to protect Your Personal Data, We cannot
                guarantee its absolute security.</p><h1>Children's Privacy</h1><p>Our Service does not address anyone
                under the age of 13. We do not knowingly collect personally identifiable information from anyone under
                the age of 13. If You are a parent or guardian and You are aware that Your child has provided Us with
                Personal Data, please contact Us. If We become aware that We have collected Personal Data from anyone
                under the age of 13 without verification of parental consent, We take steps to remove that information
                from Our servers.</p><p>If We need to rely on consent as a legal basis for processing Your information
                and Your country requires consent from a parent, We may require Your parent's consent before We collect
                and use that information.</p><h1>Links to Other Websites</h1><p>Our Service may contain links to other
                websites that are not operated by Us. If You click on a third party link, You will be directed to that
                third party's site. We strongly advise You to review the Privacy Policy of every site You visit.</p>
            <p>We have no control over and assume no responsibility for the content, privacy policies or practices of
                any third party sites or services.</p><h1>Changes to this Privacy Policy</h1><p>We may update Our
                Privacy Policy from time to time. We will notify You of any changes by posting the new Privacy Policy on
                this page.</p><p>We will let You know via email and/or a prominent notice on Our Service, prior to the
                change becoming effective and update the &quot;Last updated&quot; date at the top of this Privacy
                Policy.</p><p>You are advised to review this Privacy Policy periodically for any changes. Changes to
                this Privacy Policy are effective when they are posted on this page.</p><h1>Contact Us</h1><p>If you
                have any questions about this Privacy Policy, You can contact us:</p>
            <ul>
                <li>By email: <a  href="javascript:" onClick={cfDecodeEmail} className="_cf_email_"
                                >[email&#160;protected]</a></li>
            </ul>
            <h2>Deleting your account</h2>

            <p>If you would like to delete your data, you can do so simply by logging in and going to
                https://www.politiq.net/settings then clicking Account. There you will see a button "Delete my account".
                This will remove all personal information from our site and all your posts and comments. </p>

        </div>,
        205: "Sorry, je kunt slechts 7 tags per bericht toevoegen.",
        206: "Sorry, je kunt geen commentaar geven op dit bericht.",
        207: "Bekijk alles",
        208: "Deze doelgroep heeft nog geen leden.",
        209: "Selecteer eerst doelgroepen voor uw berichten en opmerkingen: wie kan ze zien",
        210: "Burger locaties",
        211: "Nog steeds niet zeker van het toevoegen van uw thuisadres? Bekijk deze video.",
        212: "Voeg tweede locatie toe",
        213: "Ja, dat ben ik",
        214: "Burger-locaties",
        215: "Privacy",
        216: "Account",
        217: "Antwoord prive",
        218: "Reageer in groep ...",
        219: "Reageer in het openbaar",
        220: "Upload Avatar",
        221: "Bronafbeelding:",
        222: "Laatste stemmen",
        223: <div><b>Ja</b>, denk goed na over je gebruikersnaam, omdat je deze niet kunt wijzigen. Maar maak je geen zorgen, we gebruiken je schermnaam om je te vermelden en je naam aan anderen te laten zien.</div>,
        224: "Vanzelfsprekend, hopen we.",
        225: "Probeer een sterk wachtwoord te bedenken, met een combinatie van hoofdletters, klein letters, speciale tekens, en nummers.",
        226: "Je zou verbaasd zijn hoeveel robots zich hier proberen aan te melden. We accepteren alleen mensen. Klik op het selectievakje, omdat alleen mensen weten hoe dit moet.",
        227: "Stemmen",
        228: "Bekijk profiel",
        229: "Inloggen met Facebook",
        230: "Inloggen met Twitter",
        231: "Aanmelden met Facebook",
        232: "Meld je aan met Twitter",
        233: "of...",
        234: "SCORE VAN GISTEREN",
        235: "Bedankt, kijk in uw inbox voor activatiemail",
        236: "Terug naar Inloggen",
        237: "Sturen",
        238: "Steun ons",
        239: "Steun ons binnenkort",
        240: "Founding leden",
        241: "Je officiële stem was uitgebracht",
        242: "Stemmen",
        243: "Dit is mijn officiële standpunt hierover ",
        244: "feest ",
        245: "persoon ",
        246: "Laat alleen officiële stemmen zien",
        247: "Er zijn nog geen openbare stemmen of opmerkingen. Wees de eerste!",
        248: "Onbeslist...",
        249: "laatste Reacties",
        250: "Gebruiksvoorwaarden",
        251: <div><p>Zo blij dat je dit leest. We gaan samenwerken, dus we moeten gewoon een paar dingen duidelijk maken.
        We zullen ons best doen om uw veiligheid en privacy te waarborgen. We verkopen uw gegevens niet of tonen u
        geen advertenties. We hebben allemaal te maken met een gezonde politieke discussie. En van u, alles wat we
          vragen is een paar dingen:</p>
            <ul>
                <li>- Je bent wie je zegt dat je bent (hoewel niemand zal moeten weten wie je echt bent, we zullen je
                identiteit online beschermen)
              </li>
                <li>- U bent niet hier om producten, diensten of levensstijlen te verkopen of promoten, enz
              </li>
                <li>- Je bent hier om over politiek te praten, maar ook over sociale en economische kwesties. Het plaatsen
                van dingen die geen verband houden met deze onderwerpen (vakantiefoto's, foto's van katten, enz.) Is
                in strijd met ons beleid
              </li>
                <li>- Je kunt alle politieke opvattingen hebben die je wilt, zolang je een goed persoon bent die
                respectvol is tegenover anderen en er is om de wereld een betere plek te maken. Goh, dat is vaag! We
                weten dat beslissen op basis van uw activiteit als u een "goed persoon" bent, praktisch een
                filosofische kwestie is. Wat is een goed persoon? Misschien is het niet alleen respectvol zijn dat je
                goed maakt. Misschien is het goed om te pleiten voor de waarheid, ook al doet het anderen pijn. Het
                zal een lang proces zijn om tot alles in orde te komen, en wedden dat je nooit iedereen blij zult
                maken met ons beleid, maar filosofisch gezien is dat het leven. Digitaal leven is niet eenvoudiger.
              </li>
            </ul>
            <p>Dus, als je de regels niet volgt, behouden we ons het recht voor ... je weet wel, je eruit schoppen.</p>
            <p>Het is allemaal in de naam van het bieden van de beste ervaring voor zoveel mogelijk mensen en de
              vooruitgang van de maatschappij, enz. Enz. Zijn we vierkant? Super goed. Word nu bezig!</p>
        </div>,
        252: "Ik stem voor",
        253: "Door u aan te melden gaat u akkoord met de",
        254: "Aggregation Jobs",
        255: "Ongeautoriseerd",
        256: "beheerder",
        257: "Activiteit",
        258: "Gebruikers",
        259: "Doelen",
        260: "Wie kan dit doel zien",
        261: "Wie kan reageren op dit doel",
        262: "Doelenlijst",
        263: "Doel info",
        264: "Plaats",
        265: "Privacy instellingen",
        266: "Afbeeldingen en tags",
        267: "Er zijn hier geen doelen ... nog.",
        268: "Dank je.",
        269: "In afwachting van goedkeuring door de moderator",
        270: "Orgs",
        271: "Verstuur uitnodiging",
        272: "wees de eerste die commentaar geeft op deze persoon",
        273: "wees de eerste die commentaar geeft op dit feest",
        275: "Sorry, uw reputatieniveau is niet hoog genoeg om dit te doen.",
        276: "Sorry, je gebruikersniveau is niet hoog genoeg om op dit openbare bericht te reageren.",
        277: "voer een sterk wachtwoord in ... De string moet minstens 1 kleine letter, 1 hoofdletter, 1 numeriek teken, 1 speciaal teken en de string moet 8 karakters of langer bevatten.",
        278: "Dit account is verbannen.",
        279: "Sorry, je mag vandaag niet meer posten",
        280: "Anonieme modus",
        281: "OK",
        282:<div><h6>Welkom bij de anonieme modus </h6><br/><p>Niemand zal weten dat jij het bent wanneer je een bericht plaatst. Maar negatieve interacties tellen nog steeds mee voor je reputatieniveau, dus houd de kwaliteit hoog en de toon respectvol.</p></div>,
        283:<div><p>Afsluiten naar anonieme modus</p></div>,
        284: "Anonieme gebruiker",
        285: "Stemmen kan op elk moment!",
        286: "Waarom elke paar jaar wachten met stemmen? Laten we hier een nieuw verantwoordingssysteem starten. We hebben frequentere en innovatievere manieren nodig om onze leiders te laten zien hoe we ons voelen. Vals stemmen is nog maar het begin.",
        287:<div><h5>Wij zijn</h5><h2>Het nieuwe kind in de stad</h2><p>Een nieuw sociaal platform gewijd aan politiek. We nemen de goede ingrediënten van de huidige reeks sociale netwerken en voegen er een paar nieuwe aan toe om een ​​unieke ervaring te creëren. We zijn nog maar net begonnen, dus dit is nog maar het begin.</p></div>,
        288:<div><h5>Anoniem maar echt</h5><p>Je hoeft je naam of locatie niet op de site te vermelden. Maar je moet wel een echt persoon zijn. Het systeem weet wie je werkelijk bent, maar je bent vrij om online een masker te dragen.</p></div>,
        289:<div><h5>Globaal maar intiem</h5><p>Over politiek praten met vreemden is misschien niets voor jou. Op de site kun je intiemer praten met vrienden en volgers.</p></div>,
        290:<div><h5>Geïntegreerde politieke gegevens</h5><p>Uw politici, overheidsfunctionarissen, verkiezingen en hun kandidaten worden allemaal standaard geïntegreerd in de site. Ze maken automatisch deel uit van de ervaring.</p></div>,
        291: "Veelgestelde vragen",
        292: "George Washington",
        293: "Een primair doel zou de opvoeding van onze jeugd in de wetenschap van de overheid moeten zijn. Welke soort kennis kan in een republiek even belangrijk zijn? En welke plicht is belangrijker dan deze te communiceren aan degenen die de toekomstige bewakers van de vrijheden van het land zullen zijn?",
        294: "Niets te zien? Ga naar de ledenpagina en kijk wie interessant is om te volgen",
        295: "Op maat",
        296: "Mannetje",
        297: "Vrouw",
        298: "Geslacht",
        299: "Verwijs naar mij als",
        300: "ze/haar/de hare",
        301: "hij/hem/zijn",
        302: "ze/hen/hun",
        303: "Selecteer Hier",
        304: "Tekst Hier",
        305: "We bevinden ons momenteel in de privé-bèta, maar u kunt zich hier aanmelden voor de nieuwsbrief.",
        306: "*Geeft aan Vereist",
        307: "E-mail*",
        308: "Voornaam*",
        309: "Achternaam*",
        310: "Weet je zeker dat je deze reactie wilt verwijderen?",
        311: "Upload een bestand kleiner dan 5 MB",
        312: "Iedereen",
        313: "Wie krijgt dit bericht te zien",
        314:<legend className="cdw">Wie kan reageren op dit bericht<span className="explain cdw">(ze moeten het natuurlijk eerst kunnen zien)</span></legend>,
        315: "Anoniem geplaatst",
        316: "Missie",
        317: "Functies",
        318: "Sorry, je hebt je postlimiet voor vandaag bereikt, probeer het morgen opnieuw",
        319: "Sorry, je gebruikersniveau is niet hoog genoeg om op de site te posten",
        320: "Sorry, uw gebruikersniveau is niet hoog genoeg om op de site te reageren",
        321: "Sorry, je hebt je reactielimiet voor vandaag bereikt, probeer het morgen opnieuw",
        322: "Niemand",
        323:<div className="cdw">Wilt u deze instellingen globaal wijzigen?<Link to={{ pathname:"/settings",state:{tabId:3}}}> Klik hier</Link></div>,
        324: "Reacties zijn uitgeschakeld voor dit bericht",
        325: "Dit bericht en reacties: Wie kan ze zien",
        326:<legend className="cdw">Dit bericht en reacties: wie kan erop reageren <span className="explain cdw">(ze zullen ze uiteraard moeten kunnen lezen)</span></legend>,
        327: "Maximale limiet bereikt",
        328: "Sorry, je mag maar 7 tags hebben per post. Als je een nieuwe toevoegt, zal het je laatste tag vervangen worden.",
        329: "Uw bevestigde wachtwoord komt niet overeen! voer het wachtwoord opnieuw in",
        330: "Gelukt!",
        331: "Gefeliciteerd! Je bent aangemeld. Klik op OK om je profiel in te vullen.",
        332: "Voer een wachtwoord in voor uw nieuwe account",
        333: "Oeps. Vergeet niet de duim omhoog, laag, of weet-nog-niet te selecteren!",
        334: "Voer een e-mailadres en wachtwoord in om u aan te melden",
        335: "Ofwel reactie is verwijderd of hier niet gevonden",
        336: "Deze pagina wordt niet gevonden",
        337: "Onderwerp standpunt",
        338: "Sorry, je gebruikersniveau is niet hoog genoeg om misbruik te melden",
        339: "Nieuwe onderwerpstanden",
        440: "U kunt een onderwerptaal toevoegen",
        441: "ga je gang, mors je lef!",
        442: "Er zijn hier geen onderwerpen... nog niet.",
        443: "Onderwerpstanden bewerken",
        444: "Er zijn hier geen onderwerpen... nog niet.",
        445: "Wie zal dit onderwerp zien",
        446: <legend className="cdw">Wie kan reageren op dit onderwerp<span className="explain cdw">(uiteraard moeten ze het eerst kunnen zien)</span></legend>,
        447: "Er is iets fout gegaan",
        448: "U hebt al onderwerpstanden voor dit onderwerp gemaakt.",
        449: "Dit onderwerp is in het Nederlands opgeslagen, maar deze wordt in het Engels opgeslagen. Als je dat goed vindt, herschrijf dan het onderwerp in het Engels. Verander anders de taal van de site en open deze pagina opnieuw.",
        450: "Deze topic stance is opgeslagen in het Engels, maar deze zal worden opgeslagen in het Nederlands. Als je dat goed vindt, herschrijf dan de topic stance in het Nederlands. Verander anders de taal van de site en open deze pagina opnieuw.",
        451: "Bewerk onderwerpstand naar hier",
        452: "wat vind jij er van?",
        453: "Standen aan",
        454: "Weet je zeker dat je de standpunten van dit onderwerp wilt verwijderen?",
        455: "Onderwerphouding succesvol verwijderd.",
        456: "Verwijderen",
        457: "Laat meer zien",
        458: "Misbruik",
        459: "HangFire",
        460: "Dit is wat ik ervan vind...",
        461: "Log in om te reageren...",
        462: "Populaire onderwerpen",
        463: "IN HUN EIGEN WOORDEN",
        464: "Politiq is eigendom van u",
        465: "Sociale media zijn belangrijk - het doel mag geen winst zijn. Leg het stadsplein in de handen van de mensen en het zal niet zo zijn. Politiq streeft ernaar een openbare trust te zijn die eigendom is van u en toegewijd is om u een veilige , doordachte omgeving om samen over ons leven te praten.",
        466: "Het is allemaal balanceren. Er is geen waterdichte oplossing. Gebruikers zullen worden geverifieerd, maar we moeten toestaan ​​dat ze anoniem zijn. Een reputatiesysteem zorgt ervoor dat iedereen zich gedraagt ​​zoals ze zouden doen in een kleine persoonlijke groep. Verkeerde informatie moet be onder de microscoop gaan, maar wat waar is en wat onwaar is, kan niet worden bepaald door een kleine groep mensen met hun eigen inherente vooroordelen. Het moet door ons allemaal worden bepaald met behulp van slimme systemen.",
        467: "Vrijheid van meningsuiting",
        468: <h4>Hoe de <span className="label-pink">vrijheid van meningsuiting</span> te beschermen maar
            <span className="label-pink">veiligheid</span> behouden? Wat
            over <span className="label-white">verkeerde informatie?</span>
        </h4>,
        469: "Dagelijkse stemmen en standpunten over onderwerpen",
        470: "Hoe gecompliceerder de wereld wordt, hoe meer tegenstrijdige informatiebronnen er zijn, hoe meer we moeten vertrouwen op degenen die we vertrouwen. Vertel ons op wie u stemt en waar u staat met betrekking tot de kwesties.",
        471: "Wij zijn de nieuwe jongen in de stad",
        472: "Een nieuw sociaal platform gewijd aan politiek. We halen de goede ingrediënten uit de huidige reeks sociale netwerken en voegen een paar nieuwe toe om een ​​unieke ervaring te creëren. We zijn nog maar net begonnen, dus dit is nog maar het begin. ",
        473: "Politiq Waarden",
        474: <div><p>Alles wat de mens nodig heeft, heeft waarden nodig. Bedrijven, overheden, sportteams, religies, organisaties, families en individuele mensen zelf. En natuurlijk sociale-mediaplatforms zoals Politiq.</p><p>Nu hebben we een missieverklaring. Dat is:<br/>Het verbeteren van de kwaliteit en effectiviteit van politieke actie, met als doel de hoogste welvaart voor de meeste mensen.</p><p>In deze missie ligt een reeks waarden besloten. Ja, ik dacht altijd dat dit soort praatjes ook saai was, maar het moet gebeuren. Als je hier je tijd gaat investeren, is het belangrijk dat je weet waar het bij ons om draait.</p>
              <p>Welvaart. Het is het belangrijkste doel van de mensheid en we ondersteunen mensen bij het bereiken van dat doel.</p><p>Liefde. Noem het oubollig, maar het is het beste gevoel ter wereld. We begrijpen dat u meer van familie en vrienden zult houden dan van anderen. Het is oké.</p><p>Vrijheid: je moet jezelf zijn, wat heeft dit anders voor zin? Bovendien begrijpen we dat u dit moet uiten aan de rest van de wereld.</p><p>Eerlijkheid. Wij geloven dat dit op de lange termijn tot meer welvaart zal leiden, zelfs ten koste van de welvaart op korte termijn.</p><p>Empathie. Een groot deel van het leven bestaat uit lijden. Laten we elkaar er doorheen helpen en ons inleven in ieders worstelingen.</p>
              <p>Beleefdheid. Het gaat er niet alleen om wat je zegt, maar ook hoe je het zegt. Het goed zeggen getuigt van respect.</p><p>Focus. Informatie is een integraal onderdeel van ons wezen. Een deel ervan is belangrijk, maar het meeste leidt af.</p><p>Nauwkeurigheid. Laten we accepteren dat hoewel de waarheid gecompliceerd is, sommige dingen waar zijn en andere niet.</p>
            </div>,
        475: "Migreren van Twitter",
        476: <div><p>In principe willen veel mensen Twitter verlaten, maar vinden het moeilijk omdat ze de investering die ze erin hebben gestoken niet willen verliezen. Ondanks al het gepraat dat Twitter een stadsplein is, is het grotendeels een marketing platform. Via advertenties of gewoon onophoudelijk tweeten proberen veel Twitter-leden je uiteindelijk iets te verkopen. Hoe meer volgers ze hebben, hoe meer warme leads ze hebben. Het is iets waard en ze willen het niet weggooien. Bovendien is er de sociale status die gepaard gaat met een grote aanhang. Het zou één ding zijn als u al deze warme leads had en alleen u hiervan op de hoogte was, maar met uw aantal volgers prominent weergegeven in uw profiel, is het een statussymbool geworden.</p>
          <p>Politiq wil het de moeite waard maken om lid te worden van ons platform. Aangezien Twitter eigenaar is van uw volgers, kunnen we ze niet migreren naar Politiq. Dus wij die warme leads zullen op Twitter moeten blijven. Maar we kunnen wel iets doen met betrekking tot de sociale status die je daar hebt opgebouwd. Omdat we ook een versie van sociale status hebben: Reputatieniveau.</p><p>Wat we bieden is het volgende:<br/>Meld je aan via de Twitter-inlogknop op Politiq en we zullen je Reputatieniveau upgraden voor de eerste 9 maanden op de site. Upgraden naar wat? Goede vraag. Afhankelijk van het aantal volgers dat u op Twitter heeft, stellen we uw reputatieniveau in op de waarde die overeenkomt met uw niveau in de onderstaande tabel. Behaal een reputatieniveau van x en dat blijft minimaal 9 maanden zo. Na die periode treedt het reputatiesysteem in werking en krijgt u wat u normaal gesproken zou krijgen op basis van uw activiteiten van de afgelopen 9 maanden.</p>
          <p>Zoals je misschien hebt gelezen, vul gewoon je profiel en kiezerslocatie in en je krijgt automatisch een Reputatieniveau van 2 op de site. Dus de onderstaande cijfers voegen we daar nog aan toe.</p>
          <table border='1' className='migrating-table'>
            <thead><tr>
              <th>Aantal volgers</th>
              <th>Extra punten</th>
            </tr></thead>
            <tbody>
            <tr>
              <td>0-100</td>
              <td>0</td>
            </tr>
            <tr>
              <td>101-1000</td>
              <td>1</td>
            </tr>
            <tr>
              <td>1001-10000</td>
              <td>2</td>
            </tr>
            <tr>
              <td>10001-50000</td>
              <td>3</td>
            </tr>
            <tr>
              <td>50001-100000</td>
              <td>4</td>
            </tr>
            <tr>
              <td>100K +</td>
              <td>5</td>
            </tr>
            </tbody>
          </table>
          <p>Waarschuwingen: dit is alleen van toepassing als u een account heeft dat is gewijd aan politieke, sociale of economische kwesties, of in de nieuwsmedia staat. U bent nog steeds onderworpen aan de voorwaarden van de site. Iedereen die structureel de voorwaarden schendt, wordt verwijderd.</p>
        </div>,
        477: "Voer e-mailadres en wachtwoord in",
        478: "E-mail bestaat al",
        479: "Interne Server Fout",
        480: "beschrijving",
        481: 'Gerelateerde organisatie',
        482: 'Of de weergavenaam of weergavelocatie is leeg in je gebruikersprofiel. Ga naar settings en vul deze in voor dat je iemand volgt.',
        483:"Chat met",
        484:"Hier kun je mee chatten",
        485:"Hier komt een kleine disclaimertekst en zo",
        486:"Deze teksten moeten in de taalbestanden staan.",
        487:"Nieuwe vraag",
        488:"Chatten",
        489:"Digitaal",
        490:"Chat mee",
        491: "Dit is niet echt. Het is ook niet officieel. Voor nu is het gewoon een experiment - hopelijk een leuk experiment, zelfs een educatief experiment, waarin we kijken of we de massa dichter bij politieke experts en hun gekozen vertegenwoordigers kunnen brengen. We zullen proberen je chats te delen met de Polly waarmee je chat. Net als je berichten en opmerkingen op Politiq, blijf positief. En maak deel uit van de cirkel van leren en onderwijzen.",
        492: "Begin overnieuw",
        493: "Ben jij dit?",
        494: "Wil je de controle over je pagina overnemen?",
        495: "We hebben 2 opties:",
        496: "1. Meld je aan met Twitter/X (als je 'Twitter/X Verified' bent).",
        497: "Binnen 48 uur hebben we je pagina toegewezen aan je nieuwe Politiq-account",
        498: "-- OF --",
        499: "2. Meld u aan met een e-mailadres van het officiële domein van uw website.",
        500: "",
        501:"AANMELDEN MET TWITTER"
    }
};
export const languageData = [
    { language: 'English', code: 'EN' },
    { language: 'Abkhazian', code: 'AB' },
    { language: 'Afar', code: 'AA' },
    { language: 'Afrikaans', code: 'AF' },
    { language: 'Akan', code: 'AK' },
    { language: 'Albanian', code: 'SQ' },
    { language: 'Amharic', code: 'AM' },
    { language: 'Arabic', code: 'AR' },
    { language: 'Aragonese', code: 'AN' },
    { language: 'Armenian', code: 'HY' },
    { language: 'Assamese', code: 'AS' },
    { language: 'Avaric', code: 'AV' },
    { language: 'Avestan', code: 'AE' },
    { language: 'Aymara', code: 'AY' },
    { language: 'Azerbaijani', code: 'AZ' },
    { language: 'Bambara', code: 'BM' },
    { language: 'Bashkir', code: 'BA' },
    { language: 'Basque', code: 'EU' },
    { language: 'Belarusian', code: 'BE' },
    { language: 'Bengali', code: 'BN' },
    { language: 'Bislama', code: 'BI' },
    { language: 'Bosnian', code: 'BS' },
    { language: 'Breton', code: 'BR' },
    { language: 'Bulgarian', code: 'BG' },
    { language: 'Burmese', code: 'MY' },
    { language: 'Catalan', code: 'CA' },
    { language: 'Chamorro', code: 'CH' },
    { language: 'Chechen', code: 'CE' },
    { language: 'Chichewa', code: 'NY' },
    { language: 'Chinese', code: 'ZH' },
    { language: 'Church Slavonic', code: 'CU' },
    { language: 'Chuvash', code: 'CV' },
    { language: 'Cornish', code: 'KW' },
    { language: 'Corsican', code: 'CO' },
    { language: 'Cree', code: 'CR' },
    { language: 'Croatian', code: 'HR' },
    { language: 'Czech', code: 'CS' },
    { language: 'Danish', code: 'DA' },
    { language: 'Divehi, Dhivehi, Maldivian', code: 'DV' },
    { language: 'Dutch, Flemish', code: 'NL' },
    { language: 'Dzongkha', code: 'DZ' },
    { language: 'Esperanto', code: 'EO' },
    { language: 'Estonian', code: 'ET' },
    { language: 'Ewe', code: 'EE' },
    { language: 'Faroese', code: 'FO' },
    { language: 'Fijian', code: 'FJ' },
    { language: 'Finnish', code: 'FI' },
    { language: 'French', code: 'FR' },
    { language: 'Western Frisian', code: 'FY' },
    { language: 'Fulah', code: 'FF' },
    { language: 'Gaelic, Scottish Gaelic', code: 'GD' },
    { language: 'Galician', code: 'GL' },
    { language: 'Ganda', code: 'LG' },
    { language: 'Georgian', code: 'KA' },
    { language: 'German', code: 'DE' },
    { language: 'Greek', code: 'EL' },
    { language: 'Kalaallisut', code: 'KL' },
    { language: 'Guarani', code: 'GN' },
    { language: 'Gujarati', code: 'GU' },
    { language: 'Haitian', code: 'HT' },
    { language: 'Hausa', code: 'HA' },
    { language: 'Hebrew', code: 'HE' },
    { language: 'Herero', code: 'HZ' },
    { language: 'Hindi', code: 'HI' },
    { language: 'Hiri Motu', code: 'HO' },
    { language: 'Hungarian', code: 'HU' },
    { language: 'Icelandic', code: 'IS' },
    { language: 'Ido', code: 'IO' },
    { language: 'Igbo', code: 'IG' },
    { language: 'Indonesian', code: 'ID' },
    { language: 'Interlingua', code: 'IA' },
    { language: 'Interlingue', code: 'IE' },
    { language: 'Inuktitut', code: 'IU' },
    { language: 'Inupiaq', code: 'IK' },
    { language: 'Irish', code: 'GA' },
    { language: 'Italian', code: 'IT' },
    { language: 'Japanese', code: 'JA' },
    { language: 'Javanese', code: 'JV' },
    { language: 'Kannada', code: 'KN' },
    { language: 'Kanuri', code: 'KR' },
    { language: 'Kashmiri', code: 'KS' },
    { language: 'Kazakh', code: 'KK' },
    { language: 'Central Khmer', code: 'KM' },
    { language: 'Kikuyu, Gikuyu', code: 'KI' },
    { language: 'Kinyarwanda', code: 'RW' },
    { language: 'Kyrgyz, Kirghiz', code: 'KY' },
    { language: 'Komi', code: 'KV' },
    { language: 'Kongo', code: 'KG' },
    { language: 'Korean', code: 'KO' },
    { language: 'Kuanyama, Kwanyama', code: 'KJ' },
    { language: 'Kurdish', code: 'KU' },
    { language: 'Lao', code: 'LO' },
    { language: 'Latin', code: 'LA' },
    { language: 'Latvian', code: 'LV' },
    { language: 'Limburgan, Limburger, Limburgish', code: 'LI' },
    { language: 'Lingala', code: 'LN' },
    { language: 'Lithuanian', code: 'LT' },
    { language: 'Luba-Katanga', code: 'LU' },
    { language: 'Luxembourgish, Letzeburgesch', code: 'LB' },
    { language: 'Macedonian', code: 'MK' },
    { language: 'Malagasy', code: 'MG' },
    { language: 'Malay', code: 'MS' },
    { language: 'Malayalam', code: 'ML' },
    { language: 'Maltese', code: 'MT' },
    { language: 'Manx', code: 'GV' },
    { language: 'Maori', code: 'MI' },
    { language: 'Marathi', code: 'MR' },
    { language: 'Marshallese', code: 'MH' },
    { language: 'Mongolian', code: 'MN' },
    { language: 'Nauru', code: 'NA' },
    { language: 'Navajo, Navaho', code: 'NV' },
    { language: 'North Ndebele', code: 'ND' },
    { language: 'South Ndebele', code: 'NR' },
    { language: 'Ndonga', code: 'NG' },
    { language: 'Nepali', code: 'NE' },
    { language: 'Norwegian', code: 'NO' },
    { language: 'Norwegian Bokmål', code: 'NB' },
    { language: 'Norwegian Nynorsk', code: 'NN' },
    { language: 'Occitan', code: 'OC' },
    { language: 'Ojibwa', code: 'OJ' },
    { language: 'Oriya', code: 'OR' },
    { language: 'Oromo', code: 'OM' },
    { language: 'Ossetian, Ossetic', code: 'OS' },
    { language: 'Pali', code: 'PI' },
    { language: 'Pashto, Pushto', code: 'PS' },
    { language: 'Persian', code: 'FA' },
    { language: 'Polish', code: 'PL' },
    { language: 'Portuguese', code: 'PT' },
    { language: 'Punjabi, Panjabi', code: 'PA' },
    { language: 'Quechua', code: 'QU' },
    { language: 'Romanian, Moldavian, Moldovan', code: 'RO' },
    { language: 'Romansh', code: 'RM' },
    { language: 'Rundi', code: 'RN' },
    { language: 'Russian', code: 'RU' },
    { language: 'Northern Sami', code: 'SE' },
    { language: 'Samoan', code: 'SM' },
    { language: 'Sango', code: 'SG' },
    { language: 'Sanskrit', code: 'SA' },
    { language: 'Sardinian', code: 'SC' },
    { language: 'Serbian', code: 'SR' },
    { language: 'Shona', code: 'SN' },
    { language: 'Sindhi', code: 'SD' },
    { language: 'Sinhala, Sinhalese', code: 'SI' },
    { language: 'Slovak', code: 'SK' },
    { language: 'Slovenian', code: 'SL' },
    { language: 'Somali', code: 'SO' },
    { language: 'Southern Sotho', code: 'ST' },
    { language: 'Spanish, Castilian', code: 'ES' },
    { language: 'Sundanese', code: 'SU' },
    { language: 'Swahili', code: 'SW' },
    { language: 'Swati', code: 'SS' },
    { language: 'Swedish', code: 'SV' },
    { language: 'Tagalog', code: 'TL' },
    { language: 'Tahitian', code: 'TY' },
    { language: 'Tajik', code: 'TG' },
    { language: 'Tamil', code: 'TA' },
    { language: 'Tatar', code: 'TT' },
    { language: 'Telugu', code: 'TE' },
    { language: 'Thai', code: 'TH' },
    { language: 'Tibetan', code: 'BO' },
    { language: 'Tigrinya', code: 'TI' },
    { language: 'Tonga', code: 'TO' },
    { language: 'Tsonga', code: 'TS' },
    { language: 'Tswana', code: 'TN' },
    { language: 'Turkish', code: 'TR' },
    { language: 'Turkmen', code: 'TK' },
    { language: 'Twi', code: 'TW' },
    { language: 'Uighur, Uyghur', code: 'UG' },
    { language: 'Ukrainian', code: 'UK' },
    { language: 'Urdu', code: 'UR' },
    { language: 'Uzbek', code: 'UZ' },
    { language: 'Venda', code: 'VE' },
    { language: 'Vietnamese', code: 'VI' },
    { language: 'Volapük', code: 'VO' },
    { language: 'Walloon', code: 'WA' },
    { language: 'Welsh', code: 'CY' },
    { language: 'Wolof', code: 'WO' },
    { language: 'Xhosa', code: 'XH' },
    { language: 'Sichuan Yi, Nuosu', code: 'II' },
    { language: 'Yiddish', code: 'YI' },
    { language: 'Yoruba', code: 'YO' },
    { language: 'Zhuang, Chuang', code: 'ZA' },
    { language: 'Zulu', code: 'ZU' }
];
export const Chatlanguage = [
    { language: 'English', code: 'EN' },
    { language: 'French', code: 'FR' },
    { language: 'German', code: 'DE' },
    { language: 'Dutch, Flemish', code: 'NL' },
    { language: 'Italian', code: 'IT' },
    { language: 'Portuguese', code: 'PT' },
    { language: 'Hindi', code: 'HI' },
    { language: 'Arabic', code: 'AR' },
    { language: 'Spanish, Castilian', code: 'ES' },
    { language: 'Russian', code: 'RU' },
    { language: 'Thai', code: 'TH' },
    { language: 'Mandarin', code: 'zho' },
    { language: 'Greek', code: 'EL' },
    { language: 'Bengali', code: 'BN' },
    { language: 'Indonesian', code: 'ID' },
    { language: 'Japanese', code: 'JA' },
    { language: 'Korean', code: 'KO' },

]

export const getLabel = (number) => {
    return (data && data[language] && data[language][number]) || '';
}
